module.exports = __webpack_public_path__ + "static/img/17.dc88501.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/17.png
// module id = ExnU
// module chunks = 0